import { render, staticRenderFns } from "./accountingPending.vue?vue&type=template&id=4456d7c1&scoped=true&"
import script from "./accountingPending.vue?vue&type=script&lang=js&"
export * from "./accountingPending.vue?vue&type=script&lang=js&"
import style0 from "./accountingPending.vue?vue&type=style&index=0&id=4456d7c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4456d7c1",
  null
  
)

export default component.exports